import {createTableState, normalizePagination} from '@/core/services/Helper'

const state = () => ({
    save: { data: {} },
    table: createTableState(),
    filterData: undefined,
})

const getters = {}

const actions = {
    async get({state, commit}, {page, filterData} = {}) {
        commit('setLoading', true)
        commit('updateTableData', [])

        state.filterData = filterData

        let params = {
            page: page?.current,
            page_limit: page?.pageSize,
        }
        if (state.filterData) params = {...params, ...state.filterData}

        try {
            const res = await this._vm.axios.get(this._vm.endpoints['company_transaction'], { params })
            const { data, meta } = res.data
            commit('updateTableData', data)
            commit('updatePagination', normalizePagination(meta))
        } finally {
            setTimeout(() => commit('setLoading', false), 250)
        }
    },

    async show({commit}, {id}) {
        const res = await this._vm.axios.get(this._vm.endpoints['company_transaction'] + '/' + id)
        if (res.data?.status) {
            commit('updateSaveData', res.data.data)
        }
        return res.data
    },

    async add({commit, dispatch}, {formData}) {
        try {
            const res = await this._vm.axios.post(this._vm.endpoints['company_transaction'], formData)
            return res.data
        } catch (error) {
            this._vm.onResponseFailure(error.response.data)
        }
    },

    async delete({commit, dispatch}, {id}) {
        const ids = Array.isArray(id) ? id : [id]
        const successDeleted = []
        if (ids.length === 0) {
            this._vm.$message.warning(this._vm.$t('messages.selectRow'))
            return successDeleted
        }
        for (const item of ids) {
            try {
                const {data} = await this._vm.axios.delete(this._vm.endpoints['company_transaction'] + '/' + item)
                if (data.status) {
                    successDeleted.push(item)
                }
            } catch (error) {
                // interceptor zaten error toastlar
            }
        }
        if (successDeleted.length) {
            this._vm.$message.success(this._vm.$t('messages.deleteOk'))
            dispatch('refresh')
        }
        return successDeleted
    },

    refresh({dispatch}) {
        dispatch('get')
    },
}

const mutations = {
    setLoading(state, val) { state.table.loading = val },
    updateTableData(state, data) { state.table.data = data },
    updatePagination(state, pagination) { state.table.pagination = pagination },
    updateSaveData(state, data) { state.save.data = data },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
